import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

/**
 * Restricts a route to users with the {@code SUPER-ADMIN} role.
 *
 * Use alongside {@code AuthGuard}; this guard does not verify the token, only
 * the role. The Sprint 04 spec restricts the {@code Administration > Clients}
 * page to SUPER-ADMIN even though the underlying {@code TENANT_MANAGE}
 * permission is also granted to {@code ADMIN}.
 */
export const superAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.userDataLoaded$.pipe(
    filter(loaded => loaded),
    take(1),
    switchMap(() => authService.getUserData().pipe(take(1))),
    map((user: any) => {
      if (user?.role === 'SUPER-ADMIN') {
        return true;
      }
      router.navigate(['/dashboard']);
      return false;
    })
  );
};
